import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EventsService } from 'src/app/services/events-service/events.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-events-events-breadcrumb-card',
  templateUrl: './events-events-breadcrumb-card.component.html',
  styleUrls: ['./events-events-breadcrumb-card.component.scss']
})
export class EventsEventsBreadcrumbCardComponent implements OnInit {

  @Input() alerts;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
    private userStorageService: UserStorageService,
              private activatedRoute: ActivatedRoute,
              private eventsService: EventsService) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    if (this.userStorageService.getFilterAlerts()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.eventsService.toggleEventsDisposition(viewDis);
  }

  public createEvent() {
    this.router.navigate(['../event'], {relativeTo: this.activatedRoute.parent});
  }

  public search(event) {
    this.eventsService.searchAlerts(event.target.value);
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }
}
